export default __webpack_public_path__ + "static/media/mosaic6.106d9215.png";